<div class="map-controls">
  <button *ngIf="trafficControl" class="traffic-button white-button" (click)="toggleTrafficLayer()">
    <img [src]="showTrafficLayer ? 'assets/traffic-color.svg' : 'assets/traffic-grey.svg'" />
  </button>
  <button *ngIf="focusControl" class="focus-button white-button" (click)="focusMap()">
    <img src="assets/track.svg" />
  </button>
  <div class="zoom-controls">
    <button class="zoom-button zoom-in"><img src="assets/zoom-in.svg" /></button>
    <div class="zoom-seperator"></div>
    <button class="zoom-button zoom-out">-</button>
  </div>
</div>
